export const PAYMENT_STATUS_ERROR_TOAST_DEFAULT =
  'Ha ocurrido un error. Por favor, inténtalo de nuevo.';

export const PAYMENT_STATUS_CONNECTION_ERROR_TITLE =
  'Parece que hubo un problema';

export const PAYMENT_STATUS_CONNECTION_ERROR_DESCRIPTION =
  'No se pudo cargar la información. Por favor, inténtalo de más tarde.';
